import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useCart } from '../../context/CartContext';
import { Droplet } from 'lucide-react';
import './FlyToCartOverlay.css';

const FlyToCartOverlay = () => {
  const { flyingParticles } = useCart();

  if (!flyingParticles || flyingParticles.length === 0) {
    return null;
  }

  return (
    <div className="fly-to-cart-container">
      <AnimatePresence>
        {flyingParticles.map((particle) => (
          <motion.div
            key={particle.id}
            initial={{
              x: particle.startX,
              y: particle.startY,
              scale: 1,
              opacity: 0.95,
              rotate: 0,
            }}
            animate={{
              x: [particle.startX, particle.midX, particle.endX],
              y: [particle.startY, particle.midY, particle.endY],
              scale: [1, 0.85, 0.3],
              opacity: [0.95, 1, 0],
              rotate: [0, -18, 30],
            }}
            exit={{ opacity: 0, scale: 0.2 }}
            transition={{
              duration: 0.48,
              ease: [0.25, 1, 0.5, 1],
            }}
            className="flying-cart-particle-wrapper"
          >
            <div className="flying-cart-particle">
              {particle.image ? (
                <img 
                  src={particle.image} 
                  alt="Test Vial" 
                  className="flying-particle-img"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    const fallback = e.target.parentElement.querySelector('.flying-particle-vial-fallback');
                    if (fallback) fallback.style.display = 'flex';
                  }}
                />
              ) : null}
              <div className="flying-particle-vial-fallback" style={{ display: particle.image ? 'none' : 'flex' }}>
                <Droplet size={18} color="#ffffff" />
              </div>
              <div className="flying-particle-sparkle" />
            </div>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
};

export default FlyToCartOverlay;
